var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c(_setup.CheckboxPolicy,{ref:"checkboxPolicyRef",attrs:{"state-key":_vm.stateKey}},[_c('div',{domProps:{"innerHTML":_vm._s(_setup.state.conf.label)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }